import { BrandKey } from '@prismamedia/one-brandkey';
import {
  NotificationTypeEnum,
  useNotification,
} from '@prismamedia/one-components';
import { getNlFactoryByBrand } from 'NLFactory/queries/newsletter';
import { isNewslettersSync } from 'NLFactory/utils';
import { GetNewslettersQuery_newsletters_Newsletter } from '__generated__/queries-newsletter';
import { useEffect } from 'react';

export const useCompareNlWithNlf = (
  newsletters: GetNewslettersQuery_newsletters_Newsletter[] | undefined,
  brandKey: BrandKey | undefined,
) => {
  const { pushNotification } = useNotification();

  const compareNewsletters = async (
    newslettersToCompare: GetNewslettersQuery_newsletters_Newsletter[],
    newsletterBrandKey: BrandKey,
  ) => {
    try {
      const nlfNewsletters = await getNlFactoryByBrand(newsletterBrandKey);
      const response = isNewslettersSync(nlfNewsletters, newslettersToCompare);
      if (!response) {
        pushNotification({
          message: 'Synchronisation des newsletters requise',
          type: NotificationTypeEnum.error,
        });
      }
    } catch (error) {
      pushNotification({
        message:
          "Une erreur s'est produite lors de la récupération des newsletter depuis NL Factory",
        type: NotificationTypeEnum.error,
      });
    }
  };

  useEffect(() => {
    newsletters &&
      newsletters.length > 0 &&
      brandKey &&
      compareNewsletters(newsletters, brandKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsletters, brandKey]);
};
